import { render, staticRenderFns } from "./CiCancellationTermsModal.vue?vue&type=template&id=2cdd798d&"
import script from "./CiCancellationTermsModal.vue?vue&type=script&lang=js&"
export * from "./CiCancellationTermsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CiCancellationTermsModal.vue"
export default component.exports